const codes = {
  black: {
    light: '#121212',
    normal: '#1c1c1c',
  },
  gray: {
    lighter: `#888888`,
    light: '#898989',
    light2: '#777777',
    normal: '#4d4d4d',
    neutral: '#454545',
    dark: '#232323',
    dark2: '#222222',
    other: '#272727',
    disabled: '#595959',
    muted: '#e0e0e0',
    muted2: '#333333',
  },
  red: {
    light: '#f100ff',
    normal: '#ff003d',
  },
  white: {
    light: '#d4d4d4',
    normal: '#d7d7d7',
  },
  yellow: {
    normal: '#d6fe36',
  },
};

export const COLORS = {
  primaryText: codes.white.normal,
  secondaryText: codes.gray.light,
  disabledText: codes.gray.normal,
  primaryErrorText: codes.red.normal,
  secondaryErrorText: codes.yellow.normal,
  primaryAlertText: codes.red.normal,
  primaryBackground: codes.black.light,
  secondaryBackground: codes.black.normal,
  primaryBorder: codes.gray.dark,
  secondaryBorder: codes.gray.light,
  primaryButtonText: codes.white.normal,
  secondaryButtonText: codes.white.light,
  primaryButtonBackground: codes.gray.normal,
  secondaryButtonBackground: codes.black.light,
  primaryButtonHoverBackground: codes.gray.light2,
  secondaryButtonHoverBackground: codes.gray.dark2,
  secondaryButtonBorder: codes.gray.light,
  primaryContactButtonText: codes.white.normal,
  primaryContactButtonBorder: codes.white.normal,
  primaryModalText: codes.white.normal,
  secondaryModalText: codes.gray.light,
  primaryCancelBackButtonBorder: codes.gray.light,
  primaryModalBorder: codes.white.normal,
  secondaryModalBorder: codes.gray.normal,
  primaryModalBackground: codes.gray.normal,
  primaryDash: codes.white.normal,
  primaryMenuItemCountBorder: codes.white.normal,
  secondaryMenuItemCountBorder: codes.white.normal,
  primaryInputText: codes.white.light,
  secondaryInputText: codes.white.normal,
  primaryInputErrorBorder: codes.red.normal,
  primaryInputBorder: codes.gray.normal,
  secondaryInputBorder: codes.gray.light,
  textInputBorder: codes.gray.dark,
  primaryProductDisplayBorder: codes.gray.dark,
  primaryProductDisplayText: codes.white.light,
  secondaryProductDisplayText: codes.white.normal,
  productDisplayAdditionalText: codes.gray.light,
  primaryProductDisplayBackground: codes.gray.dark,
  primarySearchBarText: codes.gray.normal,
  primarySearchBarBorder: codes.gray.normal,
  secondarySearchBarBorder: codes.white.normal,
  primarySearchBarClearButtonBorder: codes.gray.light,
  primaryTabBorder: codes.gray.normal,
  secondaryTabBorder: codes.white.normal,
  primaryTableButtonBackground: codes.black.light2,
  primaryTableBorder: codes.gray.normal,
  primaryLinkBorder: codes.white.normal,
  primaryConfirmButtonBorder: codes.white.normal,
  primaryEditPriceModalText: codes.white.light,
  secondaryEditPriceModalText: codes.gray.normal,
  primaryEditPriceModalBackground: codes.gray.dark,
  primaryEditPriceBorder: codes.gray.normal,
  secondaryEditPriceBorder: codes.gray.light,
  primaryEditPriceButtonBackground: codes.gray.normal,
  primaryEditPriceButtonHoverBackground: codes.gray.neutral,
  secondaryEditPriceButtonHoverBackground: codes.gray.other,
  primaryEditPriceDisabledButtonBackground: codes.gray.disabled,
  primaryEditPriceDisabledButtonText: codes.gray.muted,
  primaryEditPriceInfoText: codes.gray.muted2,
  primaryExpandedRowBorder: codes.gray.normal,
  primarySideBarBorder: codes.gray.normal,
  primaryVersionInfoBorder: codes.white.normal,
};
